import axios from 'axios';

import {ApiConfig} from './ConstantService';

export async function get_dashboard(id_token) {
    const config = {
      headers: {
        "Authorization": id_token
      }
    };

    let dashboard_data = [];
    let dashboard_response = (await axios.get(ApiConfig.dashboard_endpoint, config));

    if (dashboard_response.status === 200) {
        dashboard_data = dashboard_response.data;
    }
    return dashboard_data;
  }